"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Wrapper = styled_components_1.default.ul `
  list-style-type: none;
  padding: 0px;
`;
const RotaAccordion = (_a) => {
    var { children, isDisabled, openedItems, toggleItem } = _a, props = __rest(_a, ["children", "isDisabled", "openedItems", "toggleItem"]);
    const childrenList = Array.isArray(children)
        ? children
        : [children];
    return (react_1.default.createElement(Wrapper, Object.assign({}, props), react_1.Children.map(childrenList, (child, idx) => {
        if (!(0, react_1.isValidElement)(child))
            return null;
        const index = (child.key || idx) + "";
        const isOpened = !!(openedItems === null || openedItems === void 0 ? void 0 : openedItems.find(itemKey => itemKey === index));
        return (0, react_1.cloneElement)(child, {
            isOpened,
            isDisabled,
            toggleItem: () => toggleItem && toggleItem(index)
        });
    })));
};
exports.default = RotaAccordion;
